//Packages
import React from "react";

// antd setup
import { Layout } from "antd"
const { Footer } = Layout

//Components
// import Nav from "./Nav";

function Foot() {
	return (
		<Footer style={{ textAlign: 'center' }}></Footer>
	);
}

export default Foot;
